import { Injectable } from '@angular/core';
import { BranchLocation } from './location-bean';
import { AsyncSubject } from 'rxjs';
import { MEAPIService } from '../../services/api/me-api.service';
import { BasicAsyncResponseSuccessHandler } from '../../services/api/me-api-response';

@Injectable({
  providedIn: 'root'
})
export class LocationMapService {

  private readonly API_LOCATIONS = MEAPIService.BASE_URL + '/customer/locations?SkipATM=false';

  constructor(
    private srvApi: MEAPIService,
  ) {
  }

  public getLocations(): AsyncSubject<BranchLocation[]> {
    let ret = new AsyncSubject<BranchLocation[]>();
    this.srvApi.Get<BranchLocation[]>(this.API_LOCATIONS, [new BasicAsyncResponseSuccessHandler<BranchLocation[]>(ret)]);
    return ret;
  }

}